export const isApiUrlV3 = (url = '') => {
  return ['fe-api-makePurchaseOffer'].includes(url);
};
